module.exports = __webpack_public_path__ + "static/EmilyIsAway2-99c644099e92d34e36b5e4192bc4a5f0.webp";